import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouteGuard } from '../routing-guard';
import { RolloutProgressInspectionReportPageComponent } from './span-progress-report/rollout-progress-inspection-report-page/rollout-progress-inspection-report-page.component';
import { SpanProgressViewComponent } from './span-progress-view/span-progress-view.component';

const routes: Routes = [
  {
    path: '',
    component: SpanProgressViewComponent,
    canActivate: [RouteGuard],
  },
  {
    path: ':ifs',
    component: SpanProgressViewComponent,
    canActivate: [RouteGuard],
  },
  {
    path: ':ifs/reports',
    component: RolloutProgressInspectionReportPageComponent,
    canActivate: [RouteGuard],
    children: [
      {
        path: '?typeId=:typeId&id=:id',
        component: RolloutProgressInspectionReportPageComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SpanProgressRoutingModule {}
